import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-gray-500 mb-6">Pagina nao encontrada</p>
        <Link to="/dashboard" className="text-primary hover:underline">Ir para o Painel</Link>
      </div>
    </div>
  );
}
